/**
 * Labstep
 *
 * @module components/OrderRequest/EmptyState
 * @desc Empty state for order request
 */

import { OrderRequestActionCreate as OrderRequestCreateAction } from 'labstep-web/components/OrderRequest/Action/Create';
import { Card } from 'labstep-web/core/Card/Card';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import { OrderRequest } from 'labstep-web/models/order-request.model';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import type React from 'react';
import type { OrderRequestEmptyStateProps } from './types';

const label = getHumanReadableEntityName(
  OrderRequest.entityName,
  true,
  true,
);

export const OrderRequestEmptyState: React.FC<
  OrderRequestEmptyStateProps
> = (props) => (
  <CardEmptyState
    title={`No ${OrderRequest.getHumanReadableEntityName(
      true,
      true,
    )}`}
    explanation={
      'Track the order requests for the resources you need to restock. Include all relevant order information, such as PO numbers, receipts or invoices. Seamlessly add the items back to your inventory on arrival.'
    }
    src="/img/empty-state/orderRequests.svg"
    action={<OrderRequestCreateAction />}
    {...props}
  />
);

export const OrderRequestEmptyStateCard = () => (
  <Card header={label}>
    <OrderRequestEmptyState />
  </Card>
);
